import { addAuthorizationToHeaders } from "./CommonService"
import { getLocalStorage } from "./StorageHelper"
import noRefreshClient from "./api/NoRefreshClient"
import refreshClient, { handleErrors } from "./api/RefreshClient"

export async function getSerials(limit) {
    return noRefreshClient.get("series")
        .then(data => {
            return data.data
        })
        .catch(error => {
            handleErrors(error)
        })
}

export async function getSerialByUrl(url) {
    return noRefreshClient.get("series/url?url=" + encodeURIComponent(url))
        .then(data => {
            return data.data
        })
        .catch(error => {
            handleErrors(error)
        })
}